import { createContext,useContext } from 'react';
import { type ManualStep } from '../../utils/manualData';

export interface ManualContextType {
    isOpen: boolean;
    openManual: () => void;
    closeManual: () => void;
    toggleManual: () => void;
    currentStep: ManualStep | null;
    setManualStepId: (id: number | null) => void; // Allow manual override (e.g., for modals)
}

export const ManualContext = createContext<ManualContextType | undefined>(undefined);

export const useManual = () => {
    const context = useContext(ManualContext);
    if (context === undefined) {
        throw new Error('useManual must be used within a ManualProvider');
    }
    return context;
};
